export const styles = theme => ({
  card: {
    maxWidth: 600
  },
  dialog: {
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      width: 600
    }
  },
  hiddenSubmit: {
    display: 'none'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/components/EditDialog.js